import moment from 'moment';

import schema from './validate';
import api from '../api';
import { DATE_FORMAT } from '../../utils/query';

export const getSection = async (depotId, date, userId) => {
  const { data } = await api.get(`/depot/${depotId}/section`, {
    date: moment.utc(date, DATE_FORMAT).toDate().getTime(),
    userId,
    polling: true,
  });

  try {
    const result = await schema.validateAsync(data);

    return {
      defaultRoutes: result.defaultRoutes.sort((a, b) =>
        a.routeName.localeCompare(b.routeName)
      ),
      section: result.section.sort((a, b) =>
        a.sectionName.localeCompare(b.sectionName)
      ),
      depotStats: result.depotStats,
    };
  } catch (error) {
    // eslint-disable-next-line
    console.warn('Invalid getSection data', error);
  }
};

export const getSectionList = async (depotId, date, userId) => {
  const { data } = await api.get(`/depot/${depotId}/section/list`, {
    date: moment.utc(date, DATE_FORMAT).toDate().getTime(),
    userId,
  });

  return data;
};
